import Admin from 'hive-admin';

import FieldTable, { InputCheckbox } from './FieldTable';

const DAYS = [
  'Sunday',
  'Monday',
  'Tuesday',
  'Wednesday',
  'Thursday',
  'Friday',
  'Saturday',
];

const ORDER = [1, 2, 3, 4, 5, 6, 0];

const ROWS = ORDER.map(i => ({
  index: i,
  name: DAYS[i],
}));

Admin.addToLibrary(
  'FieldWorkingHours',
  config => FieldTable.create({
    label: 'Working hours',
    table: { showHeader: false, rowKey: 'name', size: 'small' },
    prepareValueForInput: (value = {}) => ROWS.reduce(
      (agr, { index, name }) => {
        if (
          value
          && value[index]
          && value[index].length === 2
          && value[index][0] !== -1
        ) {
          agr.push({
            index,
            name,
            supported: true,
            opens: value[index][0],
            closes: value[index][1],
          });
        } else {
          agr.push({
            index,
            name,
            supported: false,
            opens: 0,
            closes: 24,
          });
        }
        return agr;
      },
      [],
    ),
    prepareValueForForm: value => value.reduce(
      (agr, { index, supported, opens, closes }) => {
        agr[index] = supported ? [opens, closes] : [-1];
        return agr;
      },
      [],
    ),
    columns: [
      {
        key: 'supported',
        align: 'center',
        width: '50px',
        fields: [{
          name: 'supported',
          ComponentInput: InputCheckbox,
          props: {
            size: 'small',
          },
        }],
      },
      {
        key: 'label',
        getLabel: ({ name }) => name,
      },
      ...(['opens', 'closes'].map(name => ({
        key: name,
        width: '100px',
        fields: [{
          name,
          props: {
            size: 'small',
            align: 'right',
            suffix: 'h',
            placeholder: name,
          },
          getProps: ({ props }, { supported, ...rest } = {}) => ({
            ...props,
            disabled: !supported,
            value: supported ? rest[name] : 'closed',
          }),
        }],
      }))),
    ],
    ...config,
  }),
);
